export default "__VITE_ASSET__IZ_LCk2$__"